import React from 'react';

import { useIntl } from 'react-intl';

import TaskIcon from '@atlaskit/icon/core/task';

import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { filter as opportunityStatusFilter } from '../../../../../controllers/store/search/filters/opportunity-status';

import { i18n } from './messages';

const OpportunityStatusFilter = ({
	isFilterInDropdown,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
	onClearOptions,
}: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const [filterData, { loadInitialOptions, setOption, clearOptions }] = useSelectFilter({
		filterId: opportunityStatusFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { isLoading, suggestedOptions, selectedOptions } = filterData;

	const allOptions = [...selectedOptions, ...suggestedOptions];

	const label =
		fit === 'compact' && selectedOptions.length > 0
			? ''
			: formatMessage(i18n.opportunityStatusFilterLabel);

	return (
		<SelectFilter
			contentFit={fit}
			canClearFilter
			onDropdownOpen={loadInitialOptions}
			onSelectChange={(option, ...restArgs) => {
				setOption(option, ...restArgs);
				onFilterChange?.(option);
			}}
			options={allOptions}
			selectedOptions={selectedOptions}
			label={label}
			filterOrControlId={'opportunityStatus'}
			isLoading={isLoading}
			isSearchable={false}
			onClearOptions={() => {
				clearOptions();
				onClearOptions?.({ filterId: opportunityStatusFilter.id });
			}}
			isFilterInDropdown={isFilterInDropdown}
			iconBefore={<TaskIcon label="" />}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default OpportunityStatusFilter;
